import Vue from 'vue';

export default new Vue({
  methods: {
    checkEmit(event, paramObj) {
      const cbs = this._events[event];
      if (cbs) {
        this.$emit(event, paramObj);
      } else {
        paramObj.callback();
      }
    }
  }
});
